import { useEffect, useState } from "react";
import { Countdown } from "../models/countdown";
import { padZero } from "@/lib/number";

function CountDownTimer({ targetDate }: { targetDate: Date }) {
	const [countdown, setCountdown] = useState<Countdown>({
		days: 0,
		hours: 0,
		minutes: 0,
		seconds: 0,
	});

	useEffect(() => {
		const target = new Date(targetDate);
		target.setDate(target.getDate() + 1);
		target.setHours(19, 0, 0, 0);

		const intervalId = setInterval(() => {
			const now = new Date();
			const difference = target.getTime() - now.getTime();

			if (difference <= 0) {
				setCountdown({ days: 0, hours: 0, minutes: 0, seconds: 0 });
				clearInterval(intervalId);
				return;
			}

			const seconds = Math.floor((difference / 1000) % 60);
			const minutes = Math.floor((difference / (1000 * 60)) % 60);
			const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
			const days = Math.floor(difference / (1000 * 60 * 60 * 24));

			setCountdown({ days, hours, minutes, seconds });
		}, 1000);

		return () => clearInterval(intervalId);
	}, [targetDate]);

	return (
		<div className="flex flex-row items-center gap-5">
			<div>
				<div className="web-heading-h3-medium">{padZero(countdown.days)}</div>
				<div className="web-body-b1 text-gray-700">days</div>
			</div>

			<p className="web-heading-h4 mb-7 text-gray-700">:</p>

			<div>
				<div className="web-heading-h3-medium">{padZero(countdown.hours)}</div>
				<div className="web-body-b1 text-gray-700">hours</div>
			</div>

			<p className="web-heading-h4 mb-7 text-gray-700">:</p>

			<div>
				<div className="web-heading-h3-medium">
					{padZero(countdown.minutes)}
				</div>
				<div className="web-body-b1 text-gray-700">minutes</div>
			</div>

			<p className="web-heading-h4 mb-7 text-gray-700">:</p>

			<div>
				<div className="web-heading-h3-medium">
					{padZero(countdown.seconds)}
				</div>
				<div className="web-body-b1 text-gray-700">seconds</div>
			</div>
		</div>
	);
}

export default CountDownTimer;
